import Select2Multiple from 'v-select2-multiple-component';
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import axios from "axios";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import CONFIG from "@/assets/js/config.js";

export default {
  name: "timetableEdit",
  components: {
    MainLayout,
    Select2Multiple,
    Loading
  },

  data() {
    return {
      submitted: false,
      noDataMsg: CONFIG.NO_DATA_EXIST,
      isLoading: false,
      academic_year: [],
      selectedClass: 0,
      class_name: "",
      classArr: [],
      class_name_required: '',
      subjectCount: [],
      subjectArr: [],
      section_exist: '',
      timeTableData: [],
      days: [],
      time: [],
      dayCount: 0,
      timeCount: 0,
      selectedSubjects: [],
      subjectRows: [],
      teacherRows: [],
      teacherOptionsByCell: {},
      teacherMap: {},
    };
  },

  computed: {
    timetableDataMap() {
      const timetableMap = {};
      if (Array.isArray(this.timeTableData)) {
        this.timeTableData.forEach(item => {
          timetableMap[item.rowColIndex] = item.subject_name;
        });
      }
      return timetableMap;
    },
  },

  methods: {
    getTimetableMeta($classId) {
      axios.get("/timetableMeta/getDataForTimetable/" + $classId)
      .then((response) => {
        this.days = response.data[0][0];
        this.time = response.data[0][1];
        this.dayCount = this.days.length;
        this.timeCount = this.time.length;
        this.selectedSubjects = Array.from({ length: this.dayCount }, () =>
          Array.from({ length: this.timeCount }, () => null)
        );
        this.isLoading = false;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
      });
    },

    getTimeTableDetail($classId) {
      axios.get("/timetable/detail/" + $classId)
        .then(response => {
          this.timeTableData = response.data;
          if (this.timeTableData.length != 0) {
            this.class_name = response.data[0].class_name;
            this.academic_year.period_name = response.data[0].period_name;
            this.academic_year.acd_year_id = response.data[0].period_id;
          }
          this.getSubjectByClassId(this.$route.params.id);
          this.isLoading = false;
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
        });
    },

    getSubjectByClassId($classId) {
      axios.get("/class/subjectByClassId/" + $classId, {
        params: {
          acd_year_id: this.academic_year.acd_year_id,
          campus_id: this.$store.state.user.campus_id
        }
      })
      .then((response) => {
        this.subjectArr = response.data.subjectArr[0];
        this.teacherMap = response.data.teacherMap || {};
        // Once both the timetable detail + subject list are loaded, build cell maps
        if (Array.isArray(this.timeTableData) && this.days && this.time) {
          this.buildCellMaps();
        }
        this.isLoading = false;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
      });
    },

    /**
     * Build the 2D arrays used to drive the subject/teacher dropdowns and
     * preload the teacher options for the existing subject_teacher_id values.
     */
    buildCellMaps() {
      const days = this.days || [];
      const times = this.time || [];
      this.subjectRows = Array.from({ length: days.length }, () =>
        Array.from({ length: times.length }, () => "")
      );
      this.teacherRows = Array.from({ length: days.length }, () =>
        Array.from({ length: times.length }, () => "")
      );
      this.teacherOptionsByCell = {};

      this.timeTableData.forEach((item) => {
        const rowIndex = days.findIndex(d => d.id === item.day_meta_id);
        const colIndex = times.findIndex(t => t.id === item.time_meta_id);
        if (rowIndex === -1 || colIndex === -1) return;
        if (item.subject_id) {
          this.$set(this.subjectRows[rowIndex], colIndex, item.subject_id);
        }
        if (item.subject_teacher_id) {
          this.$set(this.teacherRows[rowIndex], colIndex, item.subject_teacher_id);
          if (item.subject_id) {
            // Use the cached teacherMap and ensure the saved option is visible
            const baseOptions = this.teacherMap[item.subject_id] || [];
            const exists = baseOptions.some(o => String(o.id) === String(item.subject_teacher_id));
            const options = exists ? baseOptions : [...baseOptions, { id: item.subject_teacher_id, text: '(Saved teacher)' }];
            this.$set(this.teacherOptionsByCell, `${rowIndex}_${colIndex}`, options);
          }
        }
      });
    },

    getTeacherOptionsEdit(rowIndex, colIndex) {
      const key = `${rowIndex}_${colIndex}`;
      return this.teacherOptionsByCell[key] || [];
    },

    onSubjectChangeEdit(rowIndex, colIndex, selectedSubjectId) {
      this.$set(this.teacherRows[rowIndex], colIndex, '');
      if (!selectedSubjectId || selectedSubjectId === '0' || selectedSubjectId === 0) {
        this.$set(this.teacherOptionsByCell, `${rowIndex}_${colIndex}`, []);
        return;
      }
      this.$set(this.teacherOptionsByCell, `${rowIndex}_${colIndex}`, this.teacherMap[selectedSubjectId] || []);
    },

    changeEvent(dayId, timeId, val) {
      const itemToUpdate = this.timeTableData.find(item => item.day_meta_id === dayId && item.time_meta_id === timeId);
      if (itemToUpdate) {
        itemToUpdate.subject_teacher_id = val;
      }
    },

    update() {
      this.isLoading = true;
      this.submitted = true;

      // Combine subject/teacher rows into the timeTableData sent to the server
      const days = this.days || [];
      const times = this.time || [];
      const updatedTimeTableData = this.timeTableData.map((item) => {
        const rowIndex = days.findIndex(d => d.id === item.day_meta_id);
        const colIndex = times.findIndex(t => t.id === item.time_meta_id);
        if (rowIndex === -1 || colIndex === -1) return item;
        const subjectTeacherId = this.teacherRows[rowIndex] && this.teacherRows[rowIndex][colIndex];
        return {
          ...item,
          subject_teacher_id: subjectTeacherId !== undefined && subjectTeacherId !== '' && subjectTeacherId !== '0' && subjectTeacherId !== 0
            ? subjectTeacherId
            : null,
        };
      });

      axios.post("timetable/update", {
          class_id: this.$route.params.id,
          acd_year_id: this.academic_year.acd_year_id,
          campus_id: this.$store.state.user.campus_id,
          login_id: this.$store.state.user.id,
          timeTableData: updatedTimeTableData,
        })
        .then(response => {
          if (response.data) {
              this.$notification.success("Timetable Update Successfully", {
                timer: 3,
                position: "bottomCenter",
              });
              this.$router.push({
                name: "timetableList"
              });
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },
  },

  mounted() {
    this.isLoading = true;
    const selectedClass = this.$route.params.id;
    this.getTimetableMeta(selectedClass);
    this.getTimeTableDetail(selectedClass);
  },
};
